import type { HomeCategoryKey } from "@/types/home"

/**
 * Route ownership per Home category. Leaf module (type-only api import) so the
 * nav, the route guards and the Home page share one mapping.
 */
export const CATEGORY_ROUTES: Record<HomeCategoryKey, { add: string; list: string }> = {
  glasses: { add: "/glasses/add", list: "/glasses" },
  makeup: { add: "/products/add", list: "/products" },
  viewer3d: { add: "/3d-viewer/add", list: "/3d-viewer" },
}

export const TRY_ON_CATEGORY_KEYS = [
  "makeup",
  "glasses",
] as const satisfies readonly HomeCategoryKey[]

export type TryOnCategoryKey = (typeof TRY_ON_CATEGORY_KEYS)[number]

export const isTryOnCategory = (key: HomeCategoryKey): key is TryOnCategoryKey => key !== "viewer3d"
